<div
  role="toolbar"
  aria-label="Tools"
  class="view-tools"
  data-test="viewTools">
  <ng-container *ngIf="mode === viewToolsMode.Main" gaCategory="View Toolbar">
    <!-- Chapter Navigation -->
    <div class="view-tools__group" *ngIf="paginationVisible">
      <!-- Previous -->
      <button 
        gaEvent
        gaAction="Clicked Previous Chapter"
        (click)="handlePreviousClick()"
        data-test="viewToolsPreviousChapter"
        [disabled]="(chapterIndex$ | async) === 0"
        [attr.aria-disabled]="(chapterIndex$ | async) === 0"
        aria-label="Previous Chapter"
        [matTooltip]="(previousChapter$ | async) ? 'Previous: ' + (previousChapter$ | async)?.info.displayName : ''"
        app-pin-button
        buttonType="ghost"
        class="view-tools__item"
        icon="chevron-left"
      ></button>

      <!-- Next -->
      <button 
        gaEvent
        gaAction="Clicked Next Chapter"
        (click)="handleNextClick()"
        data-test="viewToolsNextChapter"
        aria-label="Next Chapter"
        [attr.aria-disabled]="(chapterIndex$ | async) === ((chapterCount$ | async) - 1)"
        [disabled]="(chapterIndex$ | async) === ((chapterCount$ | async) - 1)"
        [matTooltip]="(nextChapter$ | async) ? 'Next: ' + (nextChapter$ | async)?.info.displayName : ''"
        app-pin-button
        buttonType="ghost"
        class="view-tools__item"
        icon="chevron-right"
      ></button>
    </div>

    <div class="view-tools__group" *ngIf="paginationVisible && !collapsePagination">
      <!-- Chapter Count -->
      <div
        gaEvent
        gaAction="Clicked Open Chapter List"
        #chapterCount
        class="view-tools__item">
        <button
          (click)="handleChapterCountClick()"
          data-test="viewToolsChapterCount"
          [attr.visible]="breakpoint !== breakpointEnum.Small"
          app-pin-button
          buttonType="ghost"
          aria-label="Toggle Chapter List"
          [matTooltip]="chaptersPopup ? 'Close Chapter List' : 'Open Chapter List'"
        >
            <div class="ph-2 text-13 text-semibold" style="white-space: nowrap;" aria-hidden="true">
              {{(chapterIndex$ | async) + 1}} of {{ (chapterCount$ | async)}}
              <app-icon icon="caret-up" class="ml-2"></app-icon>
            </div>

            <span class="visually-hidden">
              Toggle Chapter List, Chapter {{(chapterIndex$ | async) + 1}} of {{ (chapterCount$ | async)}}
            </span>
        </button>
      </div>
    </div>

    <!-- Media Controls -->
    <div class="view-tools__group" *ngIf="mediabarVisible">
      <!-- Play -->
      <button 
        gaEvent
        gaAction="Clicked Toggle Animation"
        [gaLabel]="(animationPlaying$ | async) ? 'Pause' : 'Play'"
        (click)="handlePlayClick()"
        data-test="viewToolsPlay"
        [icon]="(animationPlaying$ | async) ? 'pause' : 'play'"
        [attr.aria-label]="(animationPlaying$ | async) ? 'Pause Animation' : 'Play Animation'"
        [matTooltip]="(animationPlaying$ | async) ? 'Pause Animation' : 'Play Animation'"
        app-pin-button
        buttonType="ghost"
        class="view-tools__item"
      ></button>

      <!-- Media -->
      <button 
        gaEvent
        gaAction="Clicked Open Media Bar"
        (click)="toggleToolbar('media')"
        data-test="viewToolsMedia"
        *ngIf="mediaTemplate === mediaControlsEnum.Full"
        app-pin-button
        buttonType="ghost"
        class="view-tools__item"
        aria-label="Open Media Bar"
        matTooltip="Open Media Bar"
      >
        <app-view-scrubber [showHandle]="false" style="width: 32px; margin: 0 8px"></app-view-scrubber>
      </button>

      <!-- Audio -->
      <button 
        gaEvent
        gaAction="Clicked Toggle Audio"
        [gaLabel]="(playAudio$ | async) ? 'Mute' : 'Unmute'"
        data-test="viewToolsAudio"
        *ngIf="audioVisible"
        (click)="handleAudioClick()"
        [icon]="(playAudio$ | async) ? 'volume' : 'volume-slash'"
        [matTooltip]="(playAudio$ | async) ? 'Mute Audio' : 'Play Audio'"
        app-pin-button
        buttonType="ghost"
        class="view-tools__item"
      ></button>
    </div>
  </ng-container>


  <!-- Submenu: Tools   -->
  <ng-container *ngIf="mode === viewToolsMode.Tools" gaCategory="View Explore Tools">
    <div class="view-tools__group">
      <div role="radiogroup" class="flex">
        <button 
          gaEvent
          gaAction="Clicked Select"
          (click)="handleSelectTool(toolEnum.Select)"
          [selected]="(activeTool$ | async) === toolEnum.Select"
          app-pin-button
          buttonType="ghost"
          class="view-tools__item"
          icon="mouse-pointer"
          aria-label="Select"
          matTooltip="Select"
          data-test="viewToolsSelect"
        ></button>

        <button 
          gaEvent
          gaAction="Clicked Hide"
          (click)="handleSelectTool(toolEnum.Hide)"
          [selected]="(activeTool$ | async) === toolEnum.Hide"
          app-pin-button
          buttonType="ghost"
          class="view-tools__item"
          icon="eye-slash"
          aria-label="Hide"
          matTooltip="Hide"
          data-test="viewToolsHide"
        ></button>
        
        <button 
          gaEvent
          gaAction="Clicked Fade"
          app-pin-button
          appHideIE11
          buttonType="ghost"
          class="view-tools__item"
          aria-label="Fade"
          matTooltip="Fade"
          icon="adjust"
          data-test="viewToolsFade"
          [selected]="(activeTool$ | async) === toolEnum.Fade"
          (click)="handleSelectTool(toolEnum.Fade)">
        </button>
      </div>
    </div>
  </ng-container>
</div>
